import React, { Component } from 'react';
import PageTreeCB from '~/components/CheckBox/PageTreeCB';
export default class Second extends Component {
  render () {
    const { data = {}, isBottom = false, value = [], onChange, disabled = false } = this.props;
    return (
      <div style={{ display: 'flex', position: 'relative', flexDirection: 'column', marginLeft: 30 }}>
        <div style={{ display: 'flex' }}>
          <div style={{ height: 3, width: 40, backgroundColor: 'black', marginTop: 9 }} />
          <PageTreeCB disabled={disabled} value={value.indexOf(data.id) > -1} onClick={() => onChange([data.id])} />
          <div style={{ fontSize: 16, marginLeft: 5 }}>{data.name}</div>
        </div>
        <div style={{ height: 5 }} />
        <div style={{ position: 'absolute', width: 3, height: isBottom ? 10 : '100%', backgroundColor: 'black' }} />
      </div>
    );
  }
}
